import { useMemo } from 'react';
import { Participant } from '../../../types';

type LeaderboardTab = 'participants' | 'areas' | 'offices';

interface LeaderboardParticipant extends Participant {
  rank: number;
  area: string;
  avatar?: string;
}

export const useLeaderboardColumns = (activeTab: LeaderboardTab) => {
  return useMemo(() => {
    if (activeTab === 'participants') {
      return [
        { id: 'rank', label: 'Rank', width: '10%' },
        {
          id: 'participant',
          label: 'Participant',
          width: '70%',
          render: (row: LeaderboardParticipant) => (
            <div className="participant-cell">
              <div className="avatar">
                {row.name
                  .split(' ')
                  .map((word) => word.charAt(0).toUpperCase())
                  .join('')}
              </div>
              <span className="name">{row.name}</span>
            </div>
          ),
        },
        { id: 'area', label: 'Area', width: '20%' },
      ];
    }
    if (activeTab === 'areas') {
      return [
        { id: 'rank', label: 'Rank', width: '10%' },
        { id: 'area', label: 'Area', width: '70%' },
        {
          id: 'score',
          label: 'Score',
          width: '20%',
          render: (row: any) => <span className="score-value">{row.score} points</span>,
        },
      ];
    }
    return [
      { id: 'rank', label: 'Rank', width: '10%' },
      { id: 'office', label: 'Office', width: '70%' },
      {
        id: 'score',
        label: 'Score',
        width: '20%',
        render: (row: any) => <span className="score-value">{row.score} points</span>,
      },
    ];
  }, [activeTab]);
};
